import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const player_portals_country = (data: PLAYER_PORTALS_MODELS.Country) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    key: data?.system?.codename,
    label: elements?.name?.value,
    value: elements?.id?.value,
    countryId: elements?.country_id?.value,
    isoCode2: elements?.iso_code_2?.value,
    isoCode3: elements?.iso_code_3?.value,
    numericIso: elements?.numeric_iso?.value,
  };
};

export default player_portals_country;
